import { Theme as RadixThemesTheme } from '@radix-ui/themes';
import PropTypes from 'prop-types';
import React, { createContext, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import defaultTheme from '~/lib/theme/index';
import theme, { ACCENT_COLOR, GRAY_COLOR } from '~/lib/theme/themes';

const ThemePickerContext = createContext();

const THEME_LOCAL_STORAGE_KEY = 'current-theme';
const LIGHT = 'light';
const DARK = 'dark';

function getInitialThemeMode() {
  // theme coming from localStorage has higher priority then system preferences
  // so that the user can opt out of having the same theme as their system preference if they want
  const localStorageTheme = window.localStorage.getItem(THEME_LOCAL_STORAGE_KEY);
  const isThemeActivelyPreferredByLocalStorage = localStorageTheme;

  if (isThemeActivelyPreferredByLocalStorage) return isThemeActivelyPreferredByLocalStorage;

  const mql = window.matchMedia('(prefers-color-scheme: dark)');
  const isSystemSettingsPreferredToDark = mql.matches;
  return isSystemSettingsPreferredToDark ? DARK : LIGHT;
}

function ThemePickerProvider(props) {
  const initialThemeMode = getInitialThemeMode();

  const [themeMode, setThemeMode] = useState(initialThemeMode);
  const localTheme = themeMode === LIGHT ? theme.light : theme.dark;

  return (
    <ThemePickerContext.Provider
      value={{
        theme: themeMode,
        switchTheme: () => {
          const newThemeMode = themeMode === LIGHT ? DARK : LIGHT;
          setThemeMode(newThemeMode);
          window.localStorage.setItem(THEME_LOCAL_STORAGE_KEY, newThemeMode);
        },
      }}
    >
      <RadixThemesTheme
        accentColor={ACCENT_COLOR}
        grayColor={GRAY_COLOR}
        panelBackground='solid'
        appearance={themeMode}
      >
        <ThemeProvider
          theme={{ ...defaultTheme, ...localTheme }}
          {...props}
        />
      </RadixThemesTheme>
    </ThemePickerContext.Provider>
  );
}

ThemePickerProvider.propTypes = {
  children: PropTypes.node,
};

export { ThemePickerContext, ThemePickerProvider };
